"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_icons_Icon = require("../../../foundations/icons/Icon.js");
const library_reactAria_FocusRing = require("../../../library/react-aria/FocusRing.js");
const useButton = require("../../../chunks/useButton-DZQcT99f.js");
const iconButton = "_iconButton_1y3u9_1";
const styles = {
  iconButton,
  "iconButton-primary": "_iconButton-primary_1y3u9_19",
  "iconButton-primary--pressed": "_iconButton-primary--pressed_1y3u9_31",
  "iconButton-outline": "_iconButton-outline_1y3u9_40",
  "iconButton-outline--pressed": "_iconButton-outline--pressed_1y3u9_52",
  "iconButton-elevated": "_iconButton-elevated_1y3u9_61",
  "iconButton-elevated--pressed": "_iconButton-elevated--pressed_1y3u9_73",
  "iconButton-ghost": "_iconButton-ghost_1y3u9_82",
  "iconButton-ghost--pressed": "_iconButton-ghost--pressed_1y3u9_94"
};
const IconButtonBase = React.forwardRef(
  ({ variant = "primary", icon = "XBig", className, onPress, ...props }, ref) => {
    const buttonRef = React.useRef(null);
    const { buttonProps, isPressed } = useButton.$701a24aa0da5b062$export$ea18c227d4417cc3({ onPress, preventFocusOnPress: true }, buttonRef);
    const iconButtonClasses = clsx.clsx(
      styles.iconButton,
      styles["iconButton-" + variant],
      {
        [styles["iconButton-" + variant + "--pressed"]]: isPressed
      },
      className
    );
    return /* @__PURE__ */ jsxRuntime.jsx(library_reactAria_FocusRing.FocusRing, { children: /* @__PURE__ */ jsxRuntime.jsx("button", { ...buttonProps, ref, className: iconButtonClasses, ...props, children: /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { variant: icon, "aria-hidden": true }) }) });
  }
);
const IconButton = React.forwardRef((props, ref) => /* @__PURE__ */ jsxRuntime.jsx(IconButtonBase, { ...props, ref }));
exports.IconButton = IconButton;
exports.IconButtonBase = IconButtonBase;
